import { LogoWide } from "../logo";
import { ButtonProfile } from "~/router/tenant-page/button-profile";
import { ButtonSignOut } from "~/router/tenant-page/button-signout";
import { ButtonTutorial } from "~/router/tenant-page/button-tutorial";
import { NavLinks, useSplitNavbarRoutes } from "~/router/tenant-page/nav-links";
import { useHeaderRoutes } from "~/router/use-header-routes";
import { cn } from "~/util/cn";
import { useMetadataForActiveRoute } from "~/util/metadata-for-active-route";

export const DefaultDrawer: React.FC<{
  drawerId: string;
  disabled: boolean;
}> = ({ drawerId, disabled }) => {
  const headerRoutes = useHeaderRoutes();
  useMetadataForActiveRoute(headerRoutes);
  const { start, end } = useSplitNavbarRoutes(headerRoutes);

  return (
    <div className="drawer-side">
      <label
        htmlFor={drawerId}
        aria-label="close sidebar"
        className="drawer-overlay"
      />
      <ul className="max-w-72 flex min-h-full w-[80vw] flex-col justify-between border-r border-neutral-200 bg-base-200 p-4">
        <li className="pointer-events-none mb-8">
          <LogoWide className="h-10 w-full" />
        </li>

        <li>
          <ul
            className={cn(
              "flex flex-col gap-2",
              disabled && "pointer-events-none opacity-90",
            )}
          >
            <NavLinks routes={start} />
          </ul>
        </li>

        <li
          className={cn(
            "mt-auto",
            disabled && "pointer-events-none opacity-90",
          )}
        >
          <ul>{end.length >= 1 && <NavLinks routes={end} />}</ul>
        </li>

        <li>
          <ul
            className={cn(
              "flex flex-col gap-2",
              disabled && "pointer-events-none opacity-90",
            )}
          >
            <li>
              <ButtonProfile />
            </li>
            <li>
              <ButtonTutorial />
            </li>
            <li>
              <ButtonSignOut />
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
};
